var VTK_Utility = {
	'mainfunc': function (fn){
		window[fn].apply(null, Array.prototype.slice.call(arguments, 1));
	},

	'callFunctionOnce': function (fn, param_string, functionCalledVarName)
	{	
		if(window[functionCalledVarName] == undefined)
		{		
			this.mainfunc(fn, param_string);
			window[functionCalledVarName] = true;
		}
		return;
	},

	'openWindow': function (url,name,width,height)
	{
		newwindow = window.open(url,name,'width='+width+',height='+height);
		if (window.focus) {newwindow.focus()}
	},

	'resetTabIndex': function (form_id, tabindex_start_from)
	{
	   
	    if(tabindex_start_from == undefined){
           
	       tabindex_start_from = 1;
	    }
        var newtabindex = tabindex_start_from;
      
		jQuery("#"+form_id+" input, #"+form_id+" select, #"+form_id+" textarea, #"+form_id+" a").each(function(){
			jQuery(this).attr('tabindex', newtabindex);
			newtabindex++;
		});
	},
    
    'recalculateResetTabIndex': function (previous_form_id,form_id,start_from)
	{
	   if(start_from == undefined){           
	       start_from = 0;
        }
       
       if(jQuery('form#'+previous_form_id).length > 0){
	       var number_fields_in_previous_form = jQuery("#"+form_id+" input, #"+form_id+" select, #"+form_id+" textarea, #"+form_id+" a").length+start_from;
           VTK_Utility.resetTabIndex(form_id,number_fields_in_previous_form);           
	   }
       else
       {        
            VTK_Utility.resetTabIndex(form_id);
       }
	   
	},

    'isIE': function () {
        var myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
    }
}



// WEBPACK FOOTER //
// ../legacy/src/legacy/js/VTK_utility.js